export const METAMASK_NETWORKS = {
  main: 1,
  morden: 2,
  ropsten: 3,
  rinkeby: 4,
  kovan: 42
}

export const METAMASK_NETWORK_NAMES = {
  [METAMASK_NETWORKS.main]: 'Main Ethereum Network',
  [METAMASK_NETWORKS.morden]: 'Morden Test Network',
  [METAMASK_NETWORKS.ropsten]: 'Ropsten Test Network',
  [METAMASK_NETWORKS.rinkeby]: 'Rinkeby Test Network',
  [METAMASK_NETWORKS.kovan]: 'Kovan Test Network',
}


// WEBPACK FOOTER //
// ./src/constants/metamask.js